class SilveilNewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog || this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.storageKey = 'silveil_newsletter_popup_v1';
    this.delay = Number(this.dataset.delay || 8000);
    this.returnDays = Number(this.dataset.returnDays || 21);
    this.isEditor = this.dataset.editor === 'true';
    this.hasSuccess = this.querySelector('[data-newsletter-state="success"]') !== null;
    this.hasError = this.querySelector('[data-newsletter-state="error"]') !== null;

    if (this.handleSignupRedirect()) return;

    this.querySelectorAll('[data-newsletter-close]').forEach((button) => {
      button.addEventListener('click', () => this.dialog.close());
    });

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    this.dialog.addEventListener('close', () => this.rememberClose());

    if (this.hasSuccess || this.hasError || this.isEditor) {
      this.open();
      return;
    }

    if (this.shouldShow()) {
      this.openTimer = window.setTimeout(() => this.open(), this.delay);
    }
  }

  disconnectedCallback() {
    window.clearTimeout(this.openTimer);
  }

  readState() {
    try {
      return JSON.parse(window.localStorage.getItem(this.storageKey) || '{}');
    } catch (_error) {
      return {};
    }
  }

  handleSignupRedirect() {
    const url = new URL(window.location.href);
    if (url.searchParams.get('newsletter_subscribed') !== 'true') return false;

    try {
      window.localStorage.setItem(
        this.storageKey,
        JSON.stringify({ subscribed: true, subscribedAt: Date.now() })
      );
    } catch (_error) {
      // The confirmation still appears when storage is disabled.
    }

    const toast = this.querySelector('[data-newsletter-toast]');
    if (toast) {
      toast.hidden = false;
      window.setTimeout(() => {
        toast.classList.add('sv-newsletter__toast--leaving');
        window.setTimeout(() => toast.remove(), 280);
      }, 5000);
    }

    url.searchParams.delete('newsletter_subscribed');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    return true;
  }

  shouldShow() {
    const state = this.readState();
    if (state.subscribed) return false;
    if (!state.dismissedAt) return true;

    const elapsed = Date.now() - Number(state.dismissedAt);
    return elapsed >= this.returnDays * 24 * 60 * 60 * 1000;
  }

  open() {
    if (this.dialog.open) return;
    this.dialog.showModal();
    document.documentElement.classList.add('sv-newsletter-is-open');
  }

  rememberClose() {
    document.documentElement.classList.remove('sv-newsletter-is-open');
    if (this.isEditor) return;

    const nextState = this.hasSuccess
      ? { subscribed: true, subscribedAt: Date.now() }
      : { dismissedAt: Date.now() };

    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify(nextState));
    } catch (_error) {
      // The popup still works when storage is disabled.
    }
  }
}

if (!customElements.get('silveil-newsletter-popup')) {
  customElements.define('silveil-newsletter-popup', SilveilNewsletterPopup);
}
